import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Scroll to top on initial load (important for PWA)
window.scrollTo(0, 0);

// Also handle page visibility changes (when PWA is reopened)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      if (window.location.hash === '' && window.scrollY === 0) {
        window.scrollTo(0, 0);
      }
    }, 100);
  }
});

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('PWA: Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.log('PWA: Service Worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
